import { Product } from "../appData/productData"

export default class ProductDiscountHandler {
  constructor(private product: Product) {}

  get hasDiscount() {
    return this.product.discounts.length > 0
  }

  get hasFreeTrialDiscount() {
    return this.freeTrialDiscount != null
  }

  get freeTrialDiscount() {
    return this.product.discounts.find((discount) => discount.price === 0)
  }

  get hasPromoPriceDiscount() {
    return this.promoDiscount != null
  }

  get promoDiscount() {
    return this.product.discounts.find((discount) => discount.price != 0)
  }
}
